import React from "react";
import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";



function CustomChatbot(props) {

    const config = {
        width: "300px",
        height: "400px",
        floating: true
      };
      const theme = {
        background: "white",
        fontFamily: "Arial, Helvetica, sans-serif",
        headerBgColor: "#00B7CE",
        headerFontColor: "#fff",
        headerFontSize: "25px",
        botBubbleColor: "#2E3192 ",
        botFontColor: "#fff",
        userBubbleColor: "#fff",
        userFontColor: "#4c4c4c"
       };

    const steps = [
        {
           id: "Greet",
           message: "Hello, Welcome to our MedleyMed",
           trigger: "Ask Name"
        },
        {
           id: "Ask Name",
           message: "Please type your name?",
           trigger: "Waiting user input for name"
        },
        
        {
           id: "Waiting user input for name",
           user: true,
           trigger: "Asking options to booking"
        },
        {
           id: "Asking options to booking",
           message: "Hi {previousValue}, Please click on what you want to booking!",
           trigger: "Displaying options to booking"
        },
        {
           id: "Displaying options to booking",
           options: [
                      {
                        value: "Appointments",
                        label: "Appointments",
                        trigger: "Asking for Patient Appointment Details"
                      },
                      { 
                        value: "Orders",
                        label: "Orders",
                        trigger: "Orders Not available"
                      } ,
                      { 
                        value: "Diagnostics Orders",
                        label: "Diagnostics Orders",
                        trigger: "Diagnostics Orders Not available"
                      } 
                    ]
        },
        {
           id: "Orders Not available",
           message: "Sorry, We don't have Orders available at the  moment. Would you like to try our Appointments?",
           trigger: "Asking for Appointments after Order"
        },
        {
         id: "Diagnostics Orders Not available",
         message: "Sorry, We don't have diagnostics Orders available at the  moment. Would you like to try our Appointments?",
         trigger: "Asking for Appointments after Order"
      },
        {
           id: "Asking for Appointments after Order",
           options: [
                      {
                        value: true,
                        label: "Yes",
                        trigger: "Asking for Patient Appointment Details"
                      },
                      { 
                        value: "false",
                        label: "No",
                        trigger: "Done"
                      } 
                    ]
        },
        {
           id: "Asking for Patient Appointment Details",
           message: "Would you like to Patient Appointment Details",
           trigger: "Adding Appointment"
        },
        {
           id: "Adding Appointment",
           options: [
                      {
                        value: true,
                        label: "Yes",
                        // trigger: () => {
                        //    props.eventHandler("tomato");
                        //    return "Asking for Custumer care"  
                        //  }
                        trigger:"customer is yes"
                      },
                      { 
                        value: "false",
                        label: "No",
                        trigger: "Asking for Custumer care"
                      } 
                    ]
        },
        
        {
           id: "Asking for Custumer care",
           message: "Would you like to have Custumer care",
           trigger: "Adding Mushroom in Pizza"
        },
 
        {
           id: "Adding Mushroom in Pizza",
           options: [
                      {
                        value: true,
                        label: "Yes",
                        // trigger: () => {
                        //    props.eventHandler("mushroom");
                        //    return "Asking for Corn in Pizza"  
                        //  }
                        trigger:"customer is yes"
                      },
                      { 
                        value: "false",
                        label: "No",
                        // trigger: "Asking for Corn in Pizza"
                        trigger: "Done"
                      } 
                    ]
        },

      {
          
         id: "customer is yes",
         // "url":"http://www.techiediaries.com",
         message: "http://localhost:3100",     
         end: false
     },
        {
            id: "Done",
            message: "Have a great day !!",
            end: false
        }
];


//   return <ChatBot steps={steps} />;
return (
    <ThemeProvider theme={theme}>
       <ChatBot steps={steps} {...config} />
    </ThemeProvider>
   );
}
export default CustomChatbot;